"use client";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import clsx from "clsx";
import TurnaLogo from "./TurnaLogo";

const ThreeDLoading = ({ title, description, isIframeEnabled = true }) => {
  const t = useTranslationDetector();
  return (
    <div
      className={clsx(
        "flex items-center justify-center p-4 text-center",
        isIframeEnabled ? "mx-auto h-screen w-full max-w-[412px]" : "h-full",
      )}
    >
      <div className="flex w-full flex-col items-center justify-center gap-4 md:gap-10">
        <TurnaLogo className="text-primary w-45" />

        <div className="flex w-full flex-col items-center justify-center gap-5">
          <div className="flex flex-col items-center justify-center gap-1">
            <span className="text-lg font-semibold">{title}</span>
            <span>{description}</span>
          </div>

          <div className="flex w-full flex-col items-center justify-center gap-1.5">
            <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
              <div className="bg-primary h-full w-1/3 animate-[progress_1.4s_ease-in-out_infinite] rounded-full"></div>
            </div>
            <span className="">{t("common.pleasewait")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreeDLoading;
